export const ChangeMetaDescriptor = (value: string) => {
  const metaElement: HTMLMetaElement | null = document
    .getElementsByTagName('META')
    .namedItem('description') as HTMLMetaElement; // converting it to HTMLMetaElement since Element type returned by namedItem method doesn't have content property.

  if (metaElement) {
    metaElement.content = value;
  }
};
